import React from "react";

const EtransferSecurityOptions = (props) => {
  const options = [
    {
      text: 'What is email fraud, phishing or spearphishing, SEO poisoning, or SMS phishing?',
      handler: props.actionProvider.handleEtransferSecurityOptions1,
      id: 1,
    },
    {
      text: 'I have been offered a job as an e-Transfer agent. Does Interac work with e-Transfer businesses?',
      handler: props.actionProvider.handleEtransferSecurityOptions2,
      id: 2
    },
    {
      text: 'How do these e-Transfer business scams work?',
      handler: props.actionProvider.handleEtransferSecurityOptions3,
      id: 3
    },
    {
      text: 'How can I tell if a job offer is part of a scam? The information looks very professional.',
      handler: props.actionProvider.handleEtransferSecurityOptions4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransferSecurity-products'>{optionsMarkup}</div>;
};

export default EtransferSecurityOptions;